import React from 'react';
import { ArcButton } from '@src/core/ui';
import { ArcSocketContext } from '@src/core/socket';
import { EnRouteCommandEnum, EnRouteEventTypeEnum } from '@src/features/order/pages/take-off-to-en-route-page/entities';
import { WinchDownActionProps } from './types';
import { useConfirm } from '@src/core/controllers';
import { useFlightProvider } from '@src/features/order/provider';
import { arcSpatium } from '@src/core/extensions';
import { CommandStatusEnum } from '@src/features/order/entities';

const WinchDownAction: React.FC<WinchDownActionProps> = (props) => {
  const { serialNumber } = props;
  const { confirm } = useConfirm();
  const { arcSocket } = React.useContext(ArcSocketContext);
  const { flightData } = useFlightProvider();
  const [isLoading, setIsLoading] = React.useState(false);

  // Stop loading when websocket confirms WINCH_DELIVERY for this specific drone
  React.useEffect(() => {
    const socket = arcSocket();
    if (!socket || !serialNumber) return;

    const onMessage = (event: MessageEvent) => {
      try {
        const data = JSON.parse(event.data ?? '{}');
        
        if (data.type === 'COMMAND_STATUS') {
          
          // Only respond to WINCH_DELIVERY SUCCESS for this specific drone
          if (data?.command === CommandStatusEnum.WINCH_DELIVERY && 
              data?.status === 'SUCCESS' &&
              (data?.serialNumber === serialNumber || !data?.serialNumber)) {
            setIsLoading(false);
          }
        }
      } catch (_) {
        // ignore malformed messages
      }
    };

    socket.addEventListener('message', onMessage);
    return () => {
      socket.removeEventListener('message', onMessage);
    };
  }, [arcSocket, serialNumber]);

  // Cleanup loading state on unmount
  React.useEffect(() => {
    return () => {
      setIsLoading(false);
    };
  }, []);
    
  const winchDown = async () => {
    const ok = await confirm(
     
      'Ensure the drop zone is clear.', 'Terrain altitude: ' + arcSpatium(flightData.altitude) + '. Confirm winch down?'
    );
    if (!ok) return;

    setIsLoading(true);
    const socket = arcSocket();
    if (socket && socket.readyState === WebSocket.OPEN) {
      socket.send(
        JSON.stringify({
          type: EnRouteEventTypeEnum.WINCH_COMMAND,
          command: EnRouteCommandEnum.WINCH_DELIVERY,
          serialNumber,
        })
      );
    }
    // Failsafe: reset loading after timeout if no ws response
  };
  return (
    <ArcButton.brand 
      sx={{ width: 200 }}
      onClick={winchDown}> 
       WINCH DOWN
    </ArcButton.brand>
  );
};

export default WinchDownAction;
